// Default query validator.
// Used if we haven't specified validator per query type in SDQuery.Types
export function isValidQuery(q) {
    if (typeof q !== "object" && typeof q !== "undefined") {
        return false;
    }
    if (typeof q === "undefined") {
        return true;
    }
    else {
        if (typeof q.name !== "string") {
            return false;
        }
        if (typeof q.params !== "object") {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=isValidQuery.js.map